import React, { useRef, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Mensaje } from '../../mensajes2';

import { Dimmer} from "../../spinner";


import useTable from '../../useTable';
import { validaSoloNumero } from '../../../util/varios';
import { TableBody, TableRow, TableCell, InputAdornment } from '@mui/material'

;

import axios from 'axios';
import hex_md5 from '../../../util/Md5';
import CatalogoMesCerrado from '../../../catalogos/catalogoMesCerrado';

const CerrarAbrirMes = props => {

    /*  variables de estados */

    let op = require('../../../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');

    const btnCancela = useRef();

    const [records, setRecords] = useState()
    const [activate, setActivate] = useState(false);
    const cmbMes = useRef();
    const cmbAnio = useRef();
    const txtCodCuenta = useRef();
    const radioConciliacion = useRef();
    const [activo, setActivo] = useState(true);
    const [visibleB, setVisibleB] = useState('hidden');
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [titleModal, setTitleModal] = useState('');
    const [operacion, setOperacion] = useState()
    const fechaSistema = JSON.parse(localStorage.getItem('fechasistema'));
    const idusuario = JSON.parse(localStorage.getItem('idusuario'));
    const [catalogoM, setCatalogoM] = useState(false);




    const blanquear = () => {

        setActivate(false);


    }



    const cancelar = () => {

        blanquear();
        props.onHideCancela();
    }


    const Actualizar = () => {

        let endpoint = `${op.conexion}/api/comun/cerrarmes`;
        let body;
        let modulo = props.llamado === 1 ? 'CAJA' : props.llamado === 2 ? 'PRESUPUESTO' : 'CONTABILIDAD';
        let cade = '';
        let cta = (props.llamado === 3 ? radioConciliacion.current.checked ? parseInt(txtCodCuenta.current.value.trim()) : 0 : 0);
        if (props.llamado === 1) {
            if (operacion === 1) {
                cade = 'CERRAR CAJA';
            } else {
                cade = 'ABRIR CAJA';
            }

        } else if (props.llamado === 2) {
            if (operacion === 1) {
                cade = 'CERRAR MES';
            } else {
                cade = 'ABRIR MES';
            }
        } else if (props.llamado === 3) {
            if (operacion === 1) {
                if (radioConciliacion.current.checked) {
                    cade = 'CERRAR CONCILIACION';
                } else {
                    cade = 'CERRAR ASIENTOS';
                }

            } else {
                if (radioConciliacion.current.checked) {
                    cade = 'ABRIR CONCILIACION';
                } else {
                    cade = 'ABRIR ASIENTOS';
                }

            }
        }
        setActivate(true);

        body = {
            operacion: operacion,
            nmes: parseInt(cmbMes.current.value),
            //nanio: parseInt(cmbAnio.current[cmbAnio.current.selectedIndex].text),
            nanio: parseInt(cmbAnio.current.value),
            cmodulo: modulo,
            idcuenta: 0,
            tipoope: cade,
            idusu: idusuario,
            fechasis: fechaSistema,
            dirip: localStorage.getItem('ip'),
            dirmac: localStorage.getItem('mac'),
        };

        axios.post(endpoint, body, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then(function (response) {

            if (response.status == 200) {

                if (props.llamado === 1) {

                    if (operacion === 1) {

                        setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'La caja fue Cerrada', icono: 'exito' });

                    } else {

                        setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'La caja fue Abierta', icono: 'exito' });


                    }
                    //props.onHideCancela();
                }


            }
            setActivate(false);
        }).catch(function (error) {

            setActivate(false);
            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });

        })

    }


    const cerrarModal = () => {
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
        props.onHideCancela();
    }


    const onChangeValidar = (e) => {
        e.preventDefault();
        let sigue = true;

        if (cmbAnio.current.value === '') {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Seleccione un año fiscal', icono: 'informacion' });
            sigue = false;
            cmbAnio.current.focus()

        } else if (cmbMes.current.value === '') {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Seleccione un mes', icono: 'informacion' });
            sigue = false;
            cmbMes.current.focus()
        }

        if (sigue) {
            Actualizar()
        }
    }

    const seleccionarEfiscal = () => {
        setActivate(true);


        let endpoint = `${op.conexion}/api/comun/efiscal`;


        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then((response) => {

            if (response.status == 200) {

                setRecords(response.data)
            }

            setActivate(false);

        }).catch((error) => {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response === undefined ? 'Error de Conexion' : error.response.data.message, icono: 'error' });
            setActivate(false);

        })
    };

    const handleCatalogo = () => {
        if (!catalogoM) {
            setCatalogoM(true);
        } else {
            setCatalogoM(false);
        }

    };

    const handleAceptaCatalogo = (datos) => {
        setCatalogoM(false);
        cmbAnio.current.value = datos.anio;
        cmbMes.current.value = datos.mes1;
    }

    return (
        <Modal
            {...props}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{
                backgroundColor: 'rgba(0, 0, 0, 0.521)'
            }}
            backdrop="static"
            keyboard={false}
            onShow={() => {
                setOperacion(props.operacion);
                cmbAnio.current.focus();
                if (props.operacion === 1) {
                    setVisibleB('hidden');
                } else {
                    setVisibleB('visible');

                }
                if (props.llamado === 1) {
                    seleccionarEfiscal()
                    if (props.operacion === 1) {
                        setTitleModal('Cerrar Caja.')
                    } else {
                        setTitleModal('Abrir Caja.')

                    }
                }
            }}
        >
            <Modal.Header className='azulGradiant'>
                <Modal.Title style={{ color: "#fff" }}>{titleModal} </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Mensaje mensaje={mensaje}
                    onHide={() => {

                        mensaje.titulo === 'Exito.' ? cerrarModal() :

                            setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
                    }
                    } />
                <Dimmer active={activate} inverted>
       
      </Dimmer>

                <div className='col-md-12 mx-auto px-0 row'>
                    <div class="input-group input-group-sm mb-2 col-md-12 mx-auto">
                        <span class="input-group-text" id="inputGroup-sizing-sm">Año:</span>
                        <select ref={cmbAnio} className="form-select form-select-sm" id="inputStatus">
                            <option value="">Seleccione</option>
                            {records && records.map((item, index) => (
                                <option key={index} value={item.anio}> {item.anio} </option>
                            ))}
                        </select>
                    </div>

                    <div class="input-group input-group-sm mb-2 col-md-12 mx-auto">
                        <span class="input-group-text" id="inputGroup-sizing-sm">Desde:</span>
                        <select ref={cmbMes} className="form-select form-select-sm" id="inputStatus">
                            <option value="">Seleccione</option>
                            <option value="1">ENERO</option>
                            <option value="2">FEBRERO</option>
                            <option value="3">MARZO</option>
                            <option value="4">ABRIL</option>
                            <option value="5">MAYO</option>
                            <option value="6">JUNIO</option>
                            <option value="7">JULIO</option>
                            <option value="8">AGOSTO</option>
                            <option value="9">SEPTIEMBRE</option>
                            <option value="10">OCTUBRE</option>
                            <option value="11">NOVIEMBRE</option>
                            <option value="12">DICIEMBRE</option>
                        </select>
                    </div>




                </div>

            </Modal.Body>
            <Modal.Footer>
                <div className='col-md-12 row mx-auto'>
                    <button style={{ visibility: visibleB }} onClick={handleCatalogo} className="btn btn-primary btn-sm rounded-pill col-md-4"><i className="fa fa-search"> Buscar</i></button>
                    <button className="btn btn-success btn-sm rounded-pill col-md-4" onClick={onChangeValidar}><i className="fas fa-check-circle"> Aceptar</i> </button>
                    <button ref={btnCancela} onClick={cancelar} className="btn btn-danger btn-sm rounded-pill col-md-4"><i className="fas fa-window-close"> Cancelar</i></button>

                </div>

            </Modal.Footer>
            <CatalogoMesCerrado titulo={''} mensaje={''}
                show={catalogoM}
                onHideCancelaCat={handleCatalogo}
                onHideAceptaCat={handleAceptaCatalogo}
                tipo={1}
                modulo={'CAJA'}
            />
        </Modal>
    );
}

export default CerrarAbrirMes;